import React, { useEffect } from "react";
import { Avatar, Box, CardContent, Chip, Grid, Grid2, Typography, useTheme, Card, Skeleton } from "@mui/material";
import { ArrowOutward } from "@mui/icons-material";
import { IoIosHappy } from "react-icons/io";
import { MdOutlineArrowOutward } from "react-icons/md";
import { ArrowUpward, ArrowDownward } from "@mui/icons-material";
import { useGetCostProgressKpiQuery } from "store/slices/apis/costSlice";
import { useParams } from "react-router-dom";



const FinancialKPI = (propos) => {
    const { kpisData } = propos;
    const theme = useTheme();
    const { projectId } = useParams();
    const costFinanceRes = useGetCostProgressKpiQuery({ projectId });

    useEffect(() => {
        kpisData(costFinanceRes);
    }, [costFinanceRes])

    if (costFinanceRes?.isLoading) {
        return (
            <Box>
                <Grid2 container sx={{ mt: "10px", mx: "-10px", rowGap: "10px" }}>
                    {Array.from({ length: 4 }).map((_, index) => (
                        <Grid2 key={index} size={{ xs: 12, md: 3 }} sx={{ px: "10px" }}>
                            <Card
                                sx={{
                                    boxShadow: "none",
                                    border: "1px solid #25252517",
                                    borderRadius: "3px",
                                }}
                            >
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    p={2}
                                >
                                    <Box display="flex" alignItems="center">
                                        <Skeleton
                                            variant="rectangular"
                                            width={40}
                                            height={40}
                                            sx={{ mr: 2, borderRadius: 1 }}
                                        />
                                        <Box>
                                            <Skeleton
                                                variant="text"
                                                width={70}
                                                height={24}
                                                sx={{ mb: 0.5 }}
                                            />
                                            <Skeleton variant="text" width={120} height={20} />
                                        </Box>
                                    </Box>
                                    <Skeleton variant="circular" width={37} height={37} />
                                </Box>
                            </Card>
                        </Grid2>
                    ))}
                </Grid2>
            </Box>
        );
    }

    const kpiData = [
        {
            title: "Fund Requirement",
            value: `₹${costFinanceRes?.data?.data?.bac ?? 0} Cr`,
            change: "0%",
            changeColor: "#474747",
            iconColor: "#E0F0E4",
            textColor: '#377E36',
            dotColor: '#CE412D',
            color: "#9ED3CC",
            timeFrame: 'this month',
            status: "fund"
        },
        {
            title: "Estimated at Completion",
            value: `₹${costFinanceRes?.data?.data?.eac ?? 0} Cr`,
            change: "0",
            changeColor: "#474747",
            iconColor: "#E0F0E4",
            textColor: '#377E36',
            dotColor: '#CE412D',
            color: "#9ED3CC",
            timeFrame: 'this month',
            status: "projectCost"
        },
        {
            title: "Cost Performance Index",
            value: `${costFinanceRes?.data?.data?.cpi ?? 0}`,
            change: "0",
            changeColor: "#474747",
            iconColor: "#E0F0E4",
            textColor: '#377E36',
            dotColor: '#CE412D',
            color: "#9ED3CC",
            timeFrame: 'this month',
            status: "actualCost"
        },
        {
            title: "Actual Cost",
            value: `₹${costFinanceRes?.data?.data?.actualCost ?? 0} Cr`,
            change: "0",
            valueColor: "#CB402D",
            iconColor: "#E0F0E4",
            textColor: '#377E36',
            dotColor: '#CE412D',
            color: "#9ED3CC",
            timeFrame: 'this month',
            status: "evm"
        },
    ];


    const riskKPIData = kpiData.map((item, index) => {
        let value, change, arrow;
        let isPositive = true;

        if (item.isDate) {
            // value = moment(RiskKPI?.[item.value]).format("DD/MM/YYYY");
            value = (item.value).format("DD/MM/YYYY");
            change = "-";
            isPositive = true;
        } else {
            // value = RiskKPI?.[item.value] ?? "-";
            value = item.value ? item.value : "";
            // const changeValue = parseFloat(RiskKPI?.[item.change]);
            const changeValue = parseFloat(item.change);
            arrow = `${changeValue >= 0 ? "up" : "down"}`;
            change = isNaN(changeValue) ? "-" : `${Math.abs(changeValue)}`;

            if (item.status === "fund" ||
                item.status === "evm" ||
                item.status === "actualCost"
            ) {
                isPositive = !isNaN(changeValue) && changeValue >= 0;
            } else if (
                item.status === "projectCost"

            ) {
                isPositive = !isNaN(changeValue) && changeValue < 0;
            }
        }

        return {
            ...item,
            value,
            change,
            isPositive,
            arrow,
        };
    });
    return (
        <>
            <Grid2 container rowSpacing={1.25} columnSpacing={3} sx={{ mt: "20px" }}>
                {riskKPIData.map((item, index) => (
                    <Grid2 key={index} size={{ xs: 12, md: 3 }}>
                        <Card sx={{ boxShadow: "none", border: '1px solid #25252517', borderRadius: '3px' }}>
                            <Box display="flex" alignItems="center" justifyContent="space-between" p={2}>
                                <Box display="flex" alignItems="center">
                                    <Typography sx={{ bgcolor: item.color, width: 45, height: 45, mr: 2 }} />
                                    <Box>
                                        <Box display="flex" alignItems="center">
                                            <Typography variant="h6" sx={{ fontWeight: 700, mr: 1, color: item.valueColor, fontSize: '18px', whiteSpace: "nowrap", lineHeight: "100%", letterSpacing: "-0.4px" }}>
                                                {item.value}
                                            </Typography>
                                            {item.status && (
                                                <Chip
                                                    label={item.change}
                                                    size="small"
                                                    // icon={
                                                    //     item.arrow === "up" ? (
                                                    //         <ArrowUpward
                                                    //             sx={{
                                                    //                 fontSize: "12px !important",
                                                    //                 color: !item.isPositive
                                                    //                     ? `${item.textColor} !important`
                                                    //                     : `${item.dotColor} !important`,
                                                    //             }}
                                                    //         />
                                                    //     ) : (
                                                    //         <ArrowDownward
                                                    //             sx={{
                                                    //                 fontSize: "12px !important",
                                                    //                 color: item.isPositive
                                                    //                     ? `${item.textColor} !important`
                                                    //                     : `${item.dotColor} !important`,
                                                    //             }}
                                                    //         />
                                                    //     )
                                                    // }
                                                    sx={{
                                                        backgroundColor: item.iconColor,
                                                        color:
                                                            item.isPositive === false
                                                                ? item.dotColor
                                                                : item.textColor,
                                                        fontWeight: 500,
                                                        fontSize: "12px",
                                                        borderRadius: "4px",
                                                    }}
                                                />
                                            )}
                                            <Typography
                                                variant="body2"
                                                color="#474747"
                                                sx={{ ml: "2px", fontWeight: 400, fontSize: "13px", lineHeight: "24px", letterSpacing: "-0.4px", color: "#474747" }}
                                            >
                                                {item.timeFrame}
                                            </Typography>
                                        </Box>
                                        <Typography variant="body2" sx={{ mt: "5px", lineHeight: "100%", letterSpacing: '-0.4px', fontSize: "13px", fontWeight: 500, color: "#252525" }}>
                                            {item.title}
                                        </Typography>
                                    </Box>
                                </Box>
                                {/* {item.hasChange && (
                                                  <Avatar sx={{ bgcolor: "#fff", width: '37px', height: '37px', border: '1px solid #d3d3d3' }}>
                                                      <MdOutlineArrowOutward
                                                          style={{ color: "#252525", fontSize: '20px', cursor: 'pointer' }}
                                                          onClick={() => {
                                                              setPopupData(item);
                                                              setOpen(true);
                                                          }}
                                                      />
                                                  </Avatar>
                                              )} */}
                            </Box>
                        </Card>
                    </Grid2>
                ))}
            </Grid2>
        </>
    );
};
export default FinancialKPI;
